import React from 'react';

const TermsAndConditions = () => {
    return (
        <>
            <div className='bg-bgprimary w-full min-h-[200px]' >  </div>
            <div className="terms-conditions">
                <h1>Terms and Conditions</h1>
                <p>Welcome to West Breeze! These terms and conditions outline the rules and regulations for the use of our website.</p>
                <h2>1. Introduction</h2>
                <p>By accessing this website, we assume you accept these terms and conditions in full. Do not continue to use West Breeze if you do not agree to all the terms and conditions stated on this page.</p>
                <p>The following terminology applies to these Terms and Conditions, Privacy Statement, and Disclaimer Notice: "Client," "You," and "Your" refers to you, the person accessing this website and accepting the Company’s terms and conditions. "The Company," "Ourselves," "We," "Our," and "Us," refers to our Company.</p>
                <h2>2. Intellectual Property</h2>
                <p>The content on this website is for your general information and use only. It is subject to change without notice.</p>
                <p>All intellectual property rights are reserved. You may access this from West Breeze for your own personal use subjected to restrictions set in these terms and conditions.</p>
                <h2>3. User Responsibilities</h2>
                <p>Users must ensure that their use of the site complies with applicable laws and regulations.</p>
                <p>Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.</p>
                <h2>4. Limitation of Liability</h2>
                <p>West Breeze will not be held liable for any damages arising out of or in connection with the use of this website.</p>
                <p>This includes, without limitation, direct loss, loss of business or profits (whether or not the loss of such profits was foreseeable, arose in the normal course of things, or you have advised this Company of the possibility of such potential loss), damage caused to your computer, computer software, systems, and programs, and the data thereon or any other direct or indirect, consequential, and incidental damages.</p>
            </div>
        </>

    );
};

export default TermsAndConditions;
